module.exports = __webpack_public_path__ + "img/ogate.3acf0aa8.png";